import { WebGLRenderer, Scene, PerspectiveCamera, BufferGeometry, BufferAttribute, PointsMaterial, Points, Fog } from 'three';
import { gsap, TweenMax } from 'gsap';

export default class PixelNoise {
  constructor(imgElement, canvasElement) {
    this.canvasElement = canvasElement;
    this.camera = new PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    this.camera.position.z = this.cameraResize();
    this.camera.position.y = -.1;

    this.scene = new Scene();
    this.renderer = new WebGLRenderer({ antialias: true, alpha: true, canvas: canvasElement });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(window.devicePixelRatio);

    this.particles = [];
    this.defaultParticlesArray = null;
    this.rippleCenterX = 0;
    this.rippleCenterY = 0;
    this.animateFrame = null;
    this.animateSwitch = false;
    this.originalScrollHandler = null;
    this.timer = 0;
    
    this.init(imgElement);
    this.disableScroll();
    window.addEventListener('mousemove', this.onMouseMove.bind(this));
    window.addEventListener('resize', this.onWindowResize.bind(this));
  }

  init(imgElement) {
    const image = new Image();
    image.crossOrigin = "Anonymous";
    image.src = imgElement.src;
    image.onload = () => {
      const pixelData = this.getPixelDataFromImage(image);
      this.createParticles(pixelData, image.width, image.height);
      this.animate();
      this.setUpAnimate();
    };
  }

  cameraResize(){
    if(window.innerWidth > window.innerHeight){
      return 2
    }else{
      if(window.innerWidth < 640){
        return 2
      }else{
        return 2
      }
    }
  }

  destory(){
    cancelAnimationFrame(this.animateFrame);
    window.removeEventListener('mousemove', this.onMouseMove.bind(this));
    window.removeEventListener('resize', this.onWindowResize.bind(this));
    this.canvasElement.remove();
    this.enableScroll();
  }

  getPixelDataFromImage(image) {
    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, image.width, image.height);
    return ctx.getImageData(0, 0, image.width, image.height).data;
  }

  createParticles(pixelData, imageWidth, imageHeight) {
    const pixelSize = 1;
    const particleCount = Math.floor(imageWidth / pixelSize) * Math.floor(imageHeight / pixelSize);
    const particleGeometry = new BufferGeometry();
    const particlePositions = new Float32Array(particleCount * 3);
    const particleColors = new Float32Array(particleCount * 3);
    this.defaultParticlesArray = new Float32Array(particleCount * 3);

    let index = 0;
    for (let y = 0; y < imageHeight; y += pixelSize) {
      for (let x = 0; x < imageWidth; x += pixelSize) {
        const pixelIndex = (y * imageWidth + x) * 4;
        const r = pixelData[pixelIndex] / 255;
        const g = pixelData[pixelIndex + 1] / 255;
        const b = pixelData[pixelIndex + 2] / 255;
        const rand = ((Math.random() * 2) - 1) * .05;

        const posX = (x / imageWidth) * 2 - 1 + rand;
        const posY = -(y / imageHeight) * 2 + 1 + rand;
        const posZ = (Math.random() - 1);

        particlePositions[index * 3] = posX;
        particlePositions[index * 3 + 1] = posY;
        particlePositions[index * 3 + 2] = posZ;

        this.defaultParticlesArray[index * 3] = posX;
        this.defaultParticlesArray[index * 3 + 1] = posY;
        this.defaultParticlesArray[index * 3 + 2] = posZ;


        particleColors[index * 3] = r;
        particleColors[index * 3 + 1] = g;
        particleColors[index * 3 + 2] = b;

        index++;
      }
    }

    particleGeometry.setAttribute('color', new BufferAttribute(particleColors, 3));
    particleGeometry.setAttribute('position', new BufferAttribute(particlePositions, 3));
    const particleMaterial = new PointsMaterial({
      size: 1.0,
      vertexColors: true,
      transparent: true,
      fog: false,
      sizeAttenuation: false
    });

    this.particles = new Points(particleGeometry, particleMaterial);
    this.scene.add(this.particles);
  }

  onWindowResize() {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  }

  onMouseMove(event) {
    if(this.animateSwitch){
      const targetX = (event.clientX / window.innerWidth) * 2 - 1;
      const targetY = -(event.clientY / window.innerHeight) * 2 + 1;
    
      // GSAP アニメーション
      gsap.to(this, {
        duration: 1,
        rippleCenterX: targetX,
        rippleCenterY: targetY,
        ease: 'power2.out',
      });
    }
  }

  getScrollValue(){
    const screenValueWithoutPx = window.scrollY;
		if(screenValueWithoutPx < window.innerHeight){
			 return screenValueWithoutPx;
		}else{
			return 0
		}
  }

  disableScroll() {
    /*
    window.scrollTo(0, 0);
    this.originalScrollHandler = window.onscroll;
    window.onscroll = function () {
      window.scrollTo(0, 0);
    };
    */
  }

  enableScroll() {
    //window.onscroll = this.originalScrollHandler;
  }
  
  setUpAnimate(){
    const timer = .8
    this.particles.position.z = 1
    this.particles.material.opacity = 0
    TweenMax.to(this.particles.position, timer, {
      z: .05,
      ease: 'power1.out',
    });
    TweenMax.to(this.particles.material, timer, {
      opacity: 1,
      ease: 'power1.out',
      onComplete: () => {
        this.animateSwitch = true;
        this.enableScroll();
      },
    });
  }

  animate() {
    this.timer ++;
    const geometry = this.particles.geometry;
    
    const s = this.getScrollValue() * .0025


    this.particles.rotation.z = this.timer * .005;
		if(s != 0){
			this.camera.position.z = this.cameraResize() - s;
		}
    
    geometry.attributes.position.needsUpdate = true;
  
    this.renderer.render(this.scene, this.camera);
    this.animateFrame = requestAnimationFrame(this.animate.bind(this));
  }
}